import { resolveI18n } from "../../../commons/services/Translation"

export const LabelWidth = (i18n) => {
  return resolveI18n({ i18n, ko: 200, en: 250, vi: 310 })
}

export const LabelWidthLinkedDeviceInput = (i18n) => {
  return resolveI18n({ i18n, ko: 150, en: 180, vi: 200 })
}

export const DetailCarrierInfoGrid = (i18n) => {
  return resolveI18n({ i18n, ko: "1fr 1fr 1fr 1fr", en: "7fr 7fr 8fr 6fr", vi: "3fr 3fr 4fr 3fr" })
}